<!-- Created by Alex Poh. on 20/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div class="curr-school-statistic-school-admin">
  <div *ngIf="assessmentChartNoData" class="dashboard-item-container">
    <div class="assessment-chart-no-data">
      <img src="/assets/images/colored/amico.svg" />
      <div class="assessment-chart-no-data-text">{{ 'shared.performanceChart.noData' | translate }}</div>
    </div>
  </div>
  <div *ngIf="!assessmentChartNoData" class="dashboard-item-container">
    <div class="chart-title">Cumulative Tests Results</div>

    <div class="assessment-chart-loader" *ngIf="assessmentChartLoading">
      <mat-spinner [strokeWidth]="5" [diameter]="56"></mat-spinner>
    </div>

    <ng-container *ngIf="!assessmentChartLoading">
      <div class="chart-filters">
        <div class="chart-filters-item"><span>Avg. Grade: {{assessmentResultsMark ?? '-'}}</span></div>
        <div class="chart-filters-item assessment-chart-subjects">
          <curr-dropdown-component-v2
            [placeholder]="'Select Teacher'"
            [selectedValue]="[]"
            [options]="assessmentChartTeachers"
            (selectedValueChange)="assessmentChartTeacherChange($event)">
          </curr-dropdown-component-v2>

          <curr-dropdown-component-v2
            [isDisabled]="subjectsDropdownDisabled"
            [placeholder]="'Select Subject'"
            [selectedValue]="assessmentChartSubjects.length > 0 ? assessmentChartSubjects[0].value : []"
            [options]="assessmentChartSubjects"
            (selectedValueChange)="assessmentChartSubjectsChange($event)">
          </curr-dropdown-component-v2>
        </div>
      </div>
      <div class="chart-date">{{ assessmentResultDate }}</div>
      <curr-assessment-results-chart [data]="assessmentResultsChart" [month]="assessmentResultsChartMonth"></curr-assessment-results-chart>
    </ng-container>
  </div>
</div>
